import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// ─── DATABASE SCHEMA (run this in Supabase SQL editor) ───────────────────────
//
// -- PRODUCTS TABLE
// create table products (
//   id uuid default gen_random_uuid() primary key,
//   sku text not null unique,
//   supplier_code text,
//   brand text not null,
//   ean_code text,
//   hts_code text,
//   trex text,
//   factory_moq integer,
//   msds_sheet text,
//   user_manual text,
//   product_type text,
//   gender text,
//   country_of_origin text default 'China',
//   factory_sku text,
//   production_time_weeks integer,
//   reference_image text,
//   packshot_image text,
//   model_image text,
//   case_size_mm text,
//   movement_model text,
//   battery text,
//   size_mm text,
//   product_weight numeric,
//   weight_including_packaging numeric,
//   packaging_image text,
//   packaging_sku text,
//   packaging_dimensions text,
//   packaging_instructions text,
//   packaging_eco_friendly boolean default false,
//   qty_per_case integer,
//   case_size_cm text,
//   specification text,
//   base_metal text,
//   plating_type text,
//   stone_gemstone text,
//   description_en text,
//   description_de text,
//   description_es text,
//   description_fr text,
//   factory_cost numeric not null default 0,
//   packaging_cost numeric default 1.4,
//   freight numeric default 0.3,
//   stock_uk integer default 0,
//   stock_de integer default 0,
//   avg_weekly_sales numeric default 2,
//   created_at timestamptz default now(),
//   updated_at timestamptz default now(),
//   created_by uuid references auth.users(id)
// );
//
// -- BRANDS TABLE
// create table brands (
//   id uuid default gen_random_uuid() primary key,
//   name text not null unique,
//   created_at timestamptz default now()
// );
//
// -- Insert default brands
// insert into brands (name) values
//   ('Kyoto Pearl'), ('Aura'), ('Emojem'), ('Wolfe & Jackson'),
//   ('The Pearl Co'), ('Jade&Stone'), ('Ashley&Taylor'), ('Encharmed'),
//   ('Voyager'), ('Cath Kidston'), ('Badgley Mischka'), ('Made by Mitchell'),
//   ('Beauty Works'), ('StylPro'), ('GlowHub');
//
// -- SETTINGS TABLE (FX rates, fees etc)
// create table settings (
//   key text primary key,
//   value text not null,
//   updated_at timestamptz default now()
// );
//
// insert into settings (key, value) values
//   ('fx_usd_gbp', '1.3'),
//   ('fx_usd_eur', '1.08'),
//   ('fee_3pl', '1.0'),
//   ('fee_pp', '3.5');
//
// -- USERS/ROLES TABLE
// create table user_roles (
//   id uuid default gen_random_uuid() primary key,
//   user_id uuid references auth.users(id) on delete cascade,
//   role text not null check (role in ('admin','editor','sales','viewer')),
//   created_at timestamptz default now()
// );
//
// -- Row Level Security
// alter table products enable row level security;
// alter table brands enable row level security;
// alter table settings enable row level security;
// alter table user_roles enable row level security;
//
// -- Policies: authenticated users can read everything
// create policy "Authenticated can read products" on products for select using (auth.role() = 'authenticated');
// create policy "Authenticated can read brands" on brands for select using (auth.role() = 'authenticated');
// create policy "Authenticated can read settings" on settings for select using (auth.role() = 'authenticated');
// create policy "Authenticated can read roles" on user_roles for select using (auth.role() = 'authenticated');
//
// -- Admins and editors can insert/update products
// create policy "Editors can insert products" on products for insert using (
//   exists (select 1 from user_roles where user_id = auth.uid() and role in ('admin','editor'))
// );
// create policy "Editors can update products" on products for update using (
//   exists (select 1 from user_roles where user_id = auth.uid() and role in ('admin','editor'))
// );
// -- Only admins can delete
// create policy "Admins can delete products" on products for delete using (
//   exists (select 1 from user_roles where user_id = auth.uid() and role = 'admin')
// );
